import React from "react"

type Props = {
  children: React.ReactNode
  duration?: number
  direction?: "ltr" | "rtl"
  gapClassName?: string
  className?: string
}

const LandingMarquee: React.FC<Props> = ({
  children,
  duration = 45,
  direction = "rtl",
  gapClassName = "gap-6",
  className = "",
}) => {
  const items = React.Children.toArray(children)
  const animationClass = direction === "ltr" ? "animate-marquee-ltr" : "animate-marquee-rtl"

  return (
    <div className={`overflow-hidden ${className}`}>
      <div
        className={`flex w-max hover:[animation-play-state:paused] ${animationClass} ${gapClassName}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {items}
        {items.map((child, index) =>
          React.isValidElement(child)
            ? React.cloneElement(child, { key: `marquee-dup-${child.key ?? index}` })
            : null
        )}
      </div>
    </div>
  )
}

export default LandingMarquee
